import React, { useEffect, useRef, useState } from "react";
import { Dropdown } from 'primereact/dropdown';
import { ListBox } from 'primereact/listbox';
import { SelectButton } from 'primereact/selectbutton';
import { InputMask } from "primereact/inputmask";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Tree } from 'primereact/tree';
import kpiService from "@services/kpi.service";
import performanceManagementService from "@services/performanceManagement.service";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { ColorPicker } from 'primereact/colorpicker';
import { Toast } from 'primereact/toast';
import useLocalStorage from "src/hooks/useLocalStorage";
import strftime from "strftime";
import { Checkbox } from 'primereact/checkbox';
import { Panel } from 'primereact/panel';
import { Toolbar } from 'primereact/toolbar';
import { Calendar } from 'primereact/calendar';
import { BlockUI } from 'primereact/blockui';
import Chart from "@containers/PerformanceManagement/Rightel/Dashboard/Chart/";
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';

export default function Dashboard() {

    const [loading, setLoading] = useState(false);
    const [dashboards, setDashboards] = useState([]);
    const [selectedDashboard, setSelectedDashboard] = useState([]);
    const [charts, setCharts] = useState([]);
    const [access, setAccess] = useState("pi pi-lock");
    const [accessName, setAccessName] = useState("private");
    const deleteClick = (id) => {
        console.log("delete", id);
        performanceManagementService.rightel_dashboard_removeSection({ id: id }).then(response2 => {
            console.log("response", response2);
            setLoading(true);
            performanceManagementService.rightel_dashboard_section_list({ id: selectedDashboard._id }).then(response => {
                setLoading(false)
                if (response.data) {
                    let charts_new = [];
                    for (const section of response.data) {

                        charts_new.push(<div><Chart data={section} deleteClick={(e) => deleteClick(section._id)} ></Chart></div>);

                    }
                    setCharts(charts_new);
                }
                else {
                }



            }).catch((e) => {
                // toast.current.show({ severity: 'error', summary: 'Error Message', detail: 'Fech kpi faild' });
                console.log(e);
                setLoading(false);
            });
        })
    };
    const getCSS = (name) => {
        if (name === "private") {
            return "pi pi-lock";
        }
        if (name === "public") {
            return "pi pi-lock-open";

        }
    }
    const accessClick = (id) => {
        performanceManagementService.rightel_dashboard_change_Access({ id: id }).then(response => {
            setLoading(true);
            selectedDashboard.access = response.data;
            setSelectedDashboard(selectedDashboard);
            // if (response.data === "private") {
            //     setAccess("pi pi-lock");
            //     setAccessName("private");
            // }
            // if (response.data === "public") {
            //     setAccess("pi pi-lock-open");
            //     setAccessName("public");

            // }
        })
    };
    useEffect(() => {
        // console.log(selectedCity);
        setCharts([]);
        let isMounted = true;
        if (selectedDashboard) {
            setLoading(true);
            console.log("selectedDashboard", selectedDashboard);
            if (selectedDashboard.access === "private") {
                setAccess("pi pi-lock");
            }
            else {
                setAccess("pi pi-lock-open");
            }
            performanceManagementService.rightel_dashboard_section_list({ id: selectedDashboard._id }).then((response) => {
                setLoading(false)
                if (isMounted) {
                    console.log("hfghfh", response.data);
                    if (response.data) {
                        let charts_new = [];
                        for (const section of response.data) {

                            charts_new.push(<div><Chart data={section} deleteClick={(e) => deleteClick(section._id)} ></Chart></div>);

                        }
                        setCharts(charts_new);
                    }
                    else {
                    }

                }

            }).catch((e) => {
                // toast.current.show({ severity: 'error', summary: 'Error Message', detail: 'Fech kpi faild' });
                console.log(e);
                setLoading(false);
            }

            );
        }

        return () => { isMounted = false };
    }, [selectedDashboard]);
    const deleteDashboardClick = (id) => {
        performanceManagementService.rightel_dashboard_delete({ id: id }).then((x) => {
            performanceManagementService.rightel_dashboard_list({}).then((response) => {
                setDashboards(response.data);
                setSelectedDashboard("")
            }).catch(e => {
            })

        }).catch(e => {
        })
    }
    useEffect(() => {
        performanceManagementService.rightel_dashboard_list({}).then((response) => {
            console.log("fffffff", response.data);
            setDashboards(response.data);
        }).catch(e => {
        })
    }, [])
    const dashboardTemplate = (option) => {
        return (
            <div class="flex justify-between">

                <Button icon="pi pi-times" onClick={() => confirm(option._id)} rounded text severity="danger" className="basis-1/5" aria-label="Cancel" />


                <div className="basis-3/5 self-center text-center text-xs w-auto" >{option.name}</div>


                <Button icon={getCSS(option.access)} onClick={() => accessClick(option._id)} rounded text severity="help" className="basis-1/5" aria-label="Cancel" />

            </div >


        );
    };
    const accept = () => {
        deleteDashboardClick(selectedDashboard._id);
    }

    const reject = () => {

    }
    const confirm = (id) => {
        confirmDialog({
            message: 'Do you want to delete this record?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            accept,
            reject
        });
    };
    return (
        <div className="flex flex-grow relative w-full bg-white ">

            {/* <div class="flex flex-row">
                <div class="basis-1/5 ">
                    <Button icon="pi pi-times" onClick={() => deleteDashboardClick()} rounded text severity="danger" label="Delete" aria-label="Cancel" />
                </div>
                <div class="basis-3/5 ">
                    <Dropdown editable optionLabel="name" value={selectedDashboard} options={dashboards} onChange={(e) => setSelectedDashboard(e.value)} className="w-full md:w-14rem" />

                </div>
                <div class="basis-1/5 ">
                    <Button icon={access} onClick={() =>accessClick()} label={accessName} rounded text severity="help" aria-label="Cancel" />
                </div>

            </div> */}

            <div className="w-72 flex-shrink-0 bg-white border-r border-gray-200 overflow-auto  justify-center flex mt-2 ">
                <ListBox filter value={selectedDashboard} onChange={(e) => setSelectedDashboard(e.value)} options={dashboards} optionLabel="name"
                    itemTemplate={dashboardTemplate} className="w-64 justify-center fixed" listStyle={{ maxHeight: '250px' }} />
            </div>
            <div className="flex w-full" style={{ maxWidth: "calc(100vw - 28rem)" }}>
                <div className=" h-full w-full">
                    <div style={{ height: "100%" }}>
                        {charts}

                    </div>
                </div>
            </div>
            <ConfirmDialog />
        </div>
    )
}